import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { z } from 'zod'

export const listDayforceBookingsRequestSchema = z.object({
  page: z.number(),
  pageSize: z.number(),
  searchTerm: z.string(),
})

export type ListDayforceBookingsRequest = z.infer<
  typeof listDayforceBookingsRequestSchema
>

export const dayforceBookingItemSchema = z.object({
  agencyId: z.string(),
  dayforceJobId: z.string(),
  jobName: z.string().nullable(),
  dayforceJobGroupId: z.string().nullable(),
  addressText: z.string(),
  workersRequired: z.number(),
  backupWorkersRequired: z.number(),
  startsAt: z.string(),
  finishesAt: z.string(),
  positionName: z.string(),
  level: z.string(),
  dayforceClientId: z.string(),
  dayforceOrganizationId: z.string(),
  organizationName: z.string(),
  shiftId: z.number().nullable(),
  companyId: z.number().nullable(),
  companyName: z.string().nullable(),
})

export type DayforceBookingItem = z.infer<typeof dayforceBookingItemSchema>
export type DayforceBookings = DayforceBookingItem[]

export const listDayforceBookingsResponseSchema = z.object({
  items: z.array(dayforceBookingItemSchema),
  totalRows: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  pageSize: z.number(),
})

export type ListDayforceBookingsResponse = z.infer<
  typeof listDayforceBookingsResponseSchema
>

export const listDayforceBookings = async (
  request: ListDayforceBookingsRequest
): Promise<ListDayforceBookingsResponse> => {
  const params: Record<string, string | number | string[] | null | undefined> =
    {
      page: request.page,
      page_size: request.pageSize,
      search_term: request.searchTerm,
    }

  const response = await api.get('/admin/dayforce/bookings', {
    params,
    paramsSerializer: queryParamSerializer,
  })
  return listDayforceBookingsResponseSchema.parse(response.data)
}
